import { useLocation } from '@xing-com/crate-core-router';
import { useHost } from '@xing-com/crate-xinglet';

const PARAMS_WHITELIST = ['register_redirect_to', 'signup_channel', 'dest_url'];

export const useSignupLink = (): string => {
  const { isPreview } = useHost();
  const externalUrl = isPreview
    ? 'https://preview.xing.com'
    : 'https://www.xing.com';

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  const queryParams = PARAMS_WHITELIST.reduce<Record<string, string>>(
    (acc, name) => {
      if (urlParams.has(name)) acc[name] = urlParams.get(name) || '';

      return acc;
    },
    {}
  );

  const signupUrl = new URL(externalUrl);
  signupUrl.pathname = 'start/signup';
  signupUrl.search = new URLSearchParams({
    registration: '1',
    ...queryParams,
  }).toString();

  return signupUrl.href;
};
